import axios from "axios";
import { subrogationapi } from "./helper";
import store from "../store"

const client = axios.create({
  baseURL: subrogationapi,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateSubrogation(item) {
    return client.post("Subrogations", item);
}
function GetSubrogations() {
  return client.get("Subrogations/GetSubrogations");
}

function GetSubrogation(claimid) {
  return client.get("Subrogations/GetSubrogation/" + claimid);
}

//payment
function CreatePayment(item) {
  return client.post("Payments", item);
}
function GetPayments(subrogationId) {
  return client.get("Payments/GetPayments/" + subrogationId);
}
function CopyPayment(paymentId) {
  var item = { paymentId: paymentId};
  return client.put("Payments/CopyPayment", item);
}
function UpdatePayment(item) {
  return client.put("Payments", item);
}

export{
    CreateSubrogation,
    GetSubrogations,
    GetSubrogation,
    CreatePayment,
    GetPayments,
    CopyPayment,
    UpdatePayment
}